const WORDS = ["DISAPPEAR", "GO OFF-GRID", "DELETE YOUR SHADOW", "PROTECT YOUR PRIVACY", "OUTRUN SURVEILLANCE"];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <div className="relative border-y border-white/10 bg-[#0a0a0a] py-6 overflow-hidden">
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="inline-flex items-center font-display font-black uppercase tracking-tight text-3xl sm:text-5xl px-8 text-white/90">
            {w}
            <span className="text-accent mx-8 text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
